import { render, staticRenderFns } from "./DatosDebito.vue?vue&type=template&id=57071ba2"
import script from "./DatosDebito.vue?vue&type=script&lang=js"
export * from "./DatosDebito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports